import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { showDependentNoticeSelector } from './selectors';
import { useStateValue } from './state_provider';
const noticeCss = "nqd3zjz";
const Notice = forwardRef((props, ref) => <p ref={ref} {...props} className={classNames(noticeCss, props.className)} />);
export const DependentNotice = () => {
  const showDependentNotice = showDependentNoticeSelector(useStateValue());
  if (!showDependentNotice) return null;
  return <Notice>
      {HtmlParser(I18n.t('publisher.event_types.members.calendar_dependent_location_notice'))}
    </Notice>;
};

require("./dependent_notice.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./dependent_notice.js");